import type { RangeItem } from '../types/range-legend.js';

export const isSingleRangeHandler = (items: RangeItem[]) => items.length === 1;
